import React, { useCallback, useEffect, useState } from "react";
import { getStandardLawData } from "../api/standard";
import PageContainer from "../components/PageContainer";
import DocLists from "../sections/standards/DocLists";

const bgImg = "/images/standards/bg-standards.jpeg";

const Law = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [pageData, setPageData] = useState(null);

  const getData = useCallback(
    () =>
      getStandardLawData()
        .then((res) => setPageData(res))
        .catch((err) => console.log(err)),
    [setPageData]
  );

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <PageContainer title={pageData?.title ?? "กฏหมาย"} bgImg={bgImg}>
      <section>
        <div className="container mx-auto mt-[-50px]">
          <div className="flex min-h-[800px] gap-4">
            {/* Sidebar */}
            <div className="w-1/4 card bg-white shadow-xl mx-auto">
              <div className="card-body">
                <ul className="space-y-2">
                  {pageData?.docgroup?.map((tab, index) => (
                    <li
                      key={index}
                      className={`p-3 rounded-lg cursor-pointer ${
                        activeTab === index
                          ? "bg-[#3F288D] text-white"
                          : "text-gray-700 hover:bg-gray-200"
                      }`}
                      onClick={() => setActiveTab(index)}
                    >
                      {tab.docgrouptitle}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="w-3/4">
              <div className="card bg-white shadow-xl mx-auto">
                <div className="card-body">
                  <DocLists
                    docs={pageData?.docgroup[activeTab]?.docitem ?? []}
                    keyLabel="doctitle"
                    onDocClick={(doc) => window.open(doc.doclink, "_blank")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
};

export default Law;
